import './InteractiveMapSearch.css';
import React, { useEffect, useState } from 'react';
import { SearchInputBox } from './SearchComponents/SearchInputBox';
import SearchResults from './SearchComponents/SearchResults';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
const DEBOUNCE_TIME = 700;
export const InteractiveMapSearch = _ref => {
  let {
    toggleSearch,
    fields,
    handleAllowSearch,
    analytics,
    params,
    allowSearch,
    defaultTypeValues,
    handleResetFiltersFromSearch,
    activeListingItemId,
    handleDisableNestedFiltersFromSearch,
    filterPinsBySearch,
    getActivePopupOnMap,
    activeTopPicks,
    toggleActiveTopPicks,
    hits
  } = _ref;
  const {
    hitsPerPage,
    placeholder,
    lbResultsFor,
    lbNoResults
  } = fields.targetItem;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const [debounceTimer, setDebounceTimer] = React.useState();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [query, setQuery] = useState('');
  useEffect(() => {
    if (query) {
      handleAllowSearch(true);
      handleDisableNestedFiltersFromSearch();
    } else {
      handleAllowSearch(false);
      handleResetFiltersFromSearch();
    }
  }, [query]);
  const handleInputChange = event => {
    const query = event.target.value;
    setQuery(query);
    clearTimeout(debounceTimer);
    setDebounceTimer(window.setTimeout(() => {
      if (query) {
        filterPinsBySearch(query);
        tealiumClickFunc(tealiumMergeClickData(analytics['searchAnalytics'], params), query);
      }
    }, DEBOUNCE_TIME));
  };
  const clearSearch = () => {
    setQuery('');
  };
  return /*#__PURE__*/React.createElement(StyledContainer, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(SearchInputBox, {
    placeholder: placeholder.value,
    rtl: rtl,
    handleInputChange: handleInputChange,
    query: query,
    clearSearch: clearSearch
  }), /*#__PURE__*/React.createElement(SearchResults, {
    lbNoResults: lbNoResults,
    sitecoreContext: sitecoreContext,
    lbResultsFor: lbResultsFor,
    defaultTypeValues: defaultTypeValues,
    activeListingItemId: activeListingItemId,
    getActivePopupOnMap: getActivePopupOnMap,
    hits: hits,
    query: query,
    mainHitsPerPage: hitsPerPage.value,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: toggleActiveTopPicks,
    analytics: analytics,
    params: params
  }));
};
const StyledContainer = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} im-search`,
    "data-cy": "search-container"
  }, children);
};
const commonStyles = "c1jsh5qi";
const ltrStyles = "lfsukou";
const rtlStyles = "r1kjlz4g";
export default InteractiveMapSearch;